AFRAME.registerComponent('advanced-material', {
    schema: {
        renderOrder: { type: 'number', default: 0 },
        depthWrite: { type: 'boolean', default: true },
        depthTest: { type: 'boolean', default: true }
    },
    init: function () {
        this.applySettings = this.applySettings.bind(this);
        this.el.addEventListener('object3dset', this.applySettings);
        if (this.el.getObject3D('mesh')) this.applySettings();
    },
    applySettings: function () {
        const mesh = this.el.getObject3D('mesh');
        if (mesh) {
            mesh.renderOrder = this.data.renderOrder;
            if (mesh.material) {
                const mats = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
                mats.forEach(mat => {
                    if (mat) {
                        mat.depthWrite = this.data.depthWrite;
                        mat.depthTest = this.data.depthTest;
                        mat.needsUpdate = true;
                    }
                });
            }
        }
    }
});

AFRAME.registerComponent('news-graph-vr', {
    init: function () {
        this.selectedNodeEl = null;
        this.hoveredNodeEl = null;
        this._nodeClickedThisFrame = false;
        this.fetchData();

        this._onSetGlobeVisible = (e) => {
            const visible = !!(e && e.detail && e.detail.visible);
            if (this.orbitSphere) {
                this.orbitSphere.visible = visible;
            }
        };
        this.el.sceneEl.addEventListener('news-graph-set-globe-visible', this._onSetGlobeVisible);
    },
    remove: function () {
        if (this.selectedNodeEl) {
            this.setSelectedNodeEl(null, null, false);
        }
        const leftArrow = document.getElementById('left-triangle-arrow-model');
        if (leftArrow) {
            leftArrow.setAttribute('position', '-1.8 2.2 -1.9');
        }
        const rightArrow = document.getElementById('right-triangle-arrow-model');
        if (rightArrow) {
            rightArrow.setAttribute('position', '1.8 2.2 -1.9');
        }
        const scene = this.el.sceneEl || document.querySelector('a-scene');
        if (this._onThemeChanged) {
            if (scene) {
                scene.removeEventListener('theme-changed', this._onThemeChanged);
                scene.removeEventListener('app-state-changed', this._onThemeChanged);
                scene.removeEventListener('news-graph-set-globe-visible', this._onSetGlobeVisible);
            }
            document.removeEventListener('theme-changed', this._onThemeChanged);
            window.removeEventListener('theme-changed', this._onThemeChanged);
        }
        if (this.edgesGroup && this.edgesGroup.parent) {
            this.edgesGroup.parent.remove(this.edgesGroup);
            this.edgesGroup = null;
        }
        if (this.orbitSphere && this.orbitSphere.parent) {
            this.orbitSphere.parent.remove(this.orbitSphere);
            this.orbitSphere = null;
        }
        if (this.labelsContainer) {
            this.labelsContainer.remove();
            this.labelsContainer = null;
        }
        try { this.el.replaceChildren(); } catch (e) {}
    },
    _isLightTheme: function (evt) {
        if (evt && evt.detail && evt.detail.themeMode) {
            return evt.detail.themeMode === 'Light';
        }
        const body = document.body;
        if (body && (body.classList.contains('light') || body.classList.contains('cb-light'))) {
            return true;
        }
        if (typeof getCacheItem === 'function') {
            const mainSettings = getCacheItem('mainSettings');
            if (mainSettings && mainSettings.themeMode === 'Light') return true;
        }
        return false;
    },
    _attachThemeListener: function () {
        if (this._themeListenerAttached) return;
        this._themeListenerAttached = true;
        const scene = this.el.sceneEl || document.querySelector('a-scene');
        this._onThemeChanged = (evt) => {
            this._updateLabelTheme(evt);
        };
        if (scene) {
            scene.addEventListener('theme-changed', this._onThemeChanged);
            scene.addEventListener('app-state-changed', this._onThemeChanged);
        }
        document.addEventListener('theme-changed', this._onThemeChanged);
        window.addEventListener('theme-changed', this._onThemeChanged);
    },
    _updateLabelTheme: function (evt) {
        const isLight = this._isLightTheme(evt);
        const nodeTextColor = isLight ? '#111827' : '#ffffff';
        const nodeOutlineColor = isLight ? '#ffffff' : '#000000';

        if (this.labelData) {
            this.labelData.forEach(({ textEl }) => {
                if (!textEl) return;
                textEl.setAttribute('color', nodeTextColor);
                textEl.setAttribute('outline-color', nodeOutlineColor);
            });
        }
    },
    fetchData: function () {
        const proxy = new window.NewsProxyAPIManager();
        proxy.fetchNarrativeTickerMap()
            .then(data => {
                if (data) this.mount(data);
            })
            .catch(err => {
                console.error("News graph data error", err);
            });
    },
    mount: function (data) {
        this.graphData = data;
        this.el.replaceChildren();
        
        this.nodes = window.NewsGraph.selectNodes(data);
        const links = window.NewsGraph.selectLinks(data.relationships || [], this.nodes);
        this.links = links;

        const pivotEl = document.createElement('a-entity');
        this.el.appendChild(pivotEl);

        const buildResult = window.NewsGraph.NewsGraphBuilder.buildNodes(this.nodes, pivotEl, true, links);
        this.meshMap = buildResult.meshMap;
        
        this.tickerPriceMap = window.NewsProxyAPIManager.buildTickerPriceMap(data);
        this.preIpoSymbols = new Set(
            (data?.tickers || [])
                .filter(t => t.possible_pre_ipo === true)
                .map(t => String(t.symbol || '').toUpperCase().trim())
        );
        this.coneInfos = buildResult.coneInfos;
        this.coneInfos.forEach(info => {
            info.flipped = window.NewsGraph.isConeFlipped(info.node, this.tickerPriceMap, this.preIpoSymbols);
        });

        this.updateNodeVisuals();

        this.separationRadius = window.NewsGraph.runForce(this.nodes, links, this.meshMap);

        const vrDistanceScale = 1.0;
        Object.values(this.meshMap).forEach(mesh => {
            if (mesh && mesh.object3D) {
                mesh.object3D.position.multiplyScalar(vrDistanceScale);
            }
        });

        this.orbitSphere = window.NewsGraph.NewsGraphBuilder.buildOrbitSphere(
            this.separationRadius, pivotEl.object3D, false, 0.55
        );
        let isGlobeVisible = true;
        try {
            const configControlEl = document.querySelector('#configure-control');
            const configControl = configControlEl && configControlEl.components['configure-control'];
            if (configControl && typeof configControl.data.isGlobeVisible !== 'undefined') {
                isGlobeVisible = !!configControl.data.isGlobeVisible;
            } else {
                const settings = (typeof getCacheItem === 'function') ? getCacheItem('configureControlSettings') : null;
                const actualSettings = settings ? (settings.value || settings) : null;
                if (actualSettings && typeof actualSettings.isGlobeVisible !== 'undefined') {
                    isGlobeVisible = !!actualSettings.isGlobeVisible;
                }
            }
        } catch (e) {
            console.warn('Failed to load globe visibility in news-graph-vr mount:', e);
        }
        if (this.orbitSphere) {
            this.orbitSphere.visible = isGlobeVisible;
        }

        this.edgesGroup = window.NewsGraph.NewsGraphBuilder.buildEdges(links, this.meshMap, pivotEl.object3D, true);

        this.buildVRLabels(this.nodes, this.meshMap, pivotEl);
        this._attachThemeListener();
        this._updateLabelTheme();

        this.adjustScaleToFit(this.nodes, this.meshMap, vrDistanceScale);

        this._saveOriginalPositions();

        this._focusAnim = null;
        this._resetAnims = null;
    },
    _saveOriginalPositions: function () {
        this._origPositions = new Map();
        if (!this.nodes || !this.meshMap) return;
        this.nodes.forEach(node => {
            const el = this.meshMap[node.id];
            if (el && el.object3D) {
                this._origPositions.set(node.id, el.object3D.position.clone());
            }
        });
    },
    buildVRLabels: function (nodes, meshMap, pivotEl) {
        this.labelData = [];
        this.labelsContainer = document.createElement('a-entity');
        this.el.appendChild(this.labelsContainer);

        nodes.forEach(node => {
            const meshEl = meshMap[node.id];
            if (!meshEl) return;
            
            if (!meshEl.hasAttribute('data-raycastable')) {
                meshEl.setAttribute('data-raycastable', '');
                
                meshEl.addEventListener('click', (evt) => {
                    this._nodeClickedThisFrame = true;
                    this.setSelectedNodeEl(this.selectedNodeEl === meshEl ? null : meshEl, node);
                });

                meshEl.addEventListener('mouseenter', () => {
                    this.hoveredNodeEl = meshEl;
                    this.updateNodeVisuals();
                });

                meshEl.addEventListener('mouseleave', () => {
                    this.hoveredNodeEl = null;
                    this.updateNodeVisuals();
                });
            }

            let raw = node.label || node.id;
            const isLight = this._isLightTheme();
            const labelColor = isLight ? '#111827' : '#ffffff';
            const outlineColor = isLight ? '#ffffff' : '#000000';
            
            if (node.type === 'ticker' || node.type === 'ticker_group') {
                const symbol = raw.split(' - ')[0].trim().toUpperCase();
                raw = symbol;
            }

            const truncated = raw.length > 32 ? raw.slice(0, 32) + '…' : raw;

            const isSphere = window.NewsGraph.NARRATIVE_TYPES.has(node.type);
            const textEl = document.createElement('a-troika-text');
            textEl.setAttribute('value', truncated);
            textEl.setAttribute('color', labelColor);
            textEl.setAttribute('font-size', isSphere ? '0.018' : '0.012');
            textEl.setAttribute('outline-color', outlineColor);
            textEl.setAttribute('outline-width', isSphere ? '0.003' : '0.002');
            textEl.setAttribute('align', 'center');
            textEl.setAttribute('depth-offset', '-1');
            textEl.setAttribute('max-width', isSphere ? '0.5' : '0.3');
            textEl.addEventListener('object3dset', () => {
                const setRO = () => { if (textEl.object3D) textEl.object3D.renderOrder = 9999; };
                if (textEl.object3D) { setRO(); } else { textEl.addEventListener('loaded', setRO, { once: true }); }
            });
            
            this.labelsContainer.appendChild(textEl);
            
            const r = meshEl.userData.radius
                ?? meshEl.object3D?.userData?.radius
                ?? 0;
            this.labelData.push({ meshEl, textEl, r, isSphere, nodeId: node.id });
        });
    },

    _getHighlightedIds: function (selectedNodeId) {
        if (!selectedNodeId || !this.links) return null;
        const ids = new Set([selectedNodeId]);
        this.links.forEach(link => {
            const src = link.source?.id ?? link.source;
            const tgt = link.target?.id ?? link.target;
            if (src === selectedNodeId) ids.add(tgt);
            if (tgt === selectedNodeId) ids.add(src);
        });
        return ids;
    },

    _startFocusAnimation: function (nodeEl) {
        if (!nodeEl || !nodeEl.object3D) return;
        const THREE = window.THREE || AFRAME.THREE;
        this._resetAnims = null;

        const selectedNodeId = Object.keys(this.meshMap).find(id => this.meshMap[id] === nodeEl) || null;
        const highlightedIds = this._getHighlightedIds(selectedNodeId);

        const groupEls = [];
        if (highlightedIds) {
            highlightedIds.forEach(id => {
                const el = this.meshMap[id];
                if (el && el.object3D) groupEls.push(el);
            });
        } else {
            groupEls.push(nodeEl);
        }

        const centroid = new THREE.Vector3();
        groupEls.forEach(el => centroid.add(el.object3D.position));
        centroid.divideScalar(groupEls.length);

        const offset = centroid.clone().negate();

        this._focusAnim = {
            type: 'focus',
            t: 0,
            entries: groupEls.map(el => ({
                nodeEl: el,
                fromPos: el.object3D.position.clone(),
                toPos: el.object3D.position.clone().add(offset)
            }))
        };
    },

    _startResetAnimation: function () {
        if (!this._origPositions || !this.meshMap) return;
        this._focusAnim = null;
        this._resetAnims = [];
        this.nodes.forEach(node => {
            const el = this.meshMap[node.id];
            const origPos = this._origPositions.get(node.id);
            if (el && el.object3D && origPos) {
                this._resetAnims.push({
                    nodeEl: el,
                    fromPos: el.object3D.position.clone(),
                    toPos: origPos.clone(),
                    t: 0
                });
            }
        });
    },

    updateNodeVisuals: function () {
        if (!this.meshMap || !this.nodes) return;

        let selectedNodeId = null;
        if (this.selectedNodeEl) {
            selectedNodeId = Object.keys(this.meshMap).find(id => this.meshMap[id] === this.selectedNodeEl) || null;
        }
        const highlightedIds = this._getHighlightedIds(selectedNodeId);

        const DIM_OPACITY = 0.04;

        this.nodes.forEach(node => {
            const el = this.meshMap[node.id];
            if (!el) return;

            const isSphere = window.NewsGraph.NARRATIVE_TYPES.has(node.type);
            const isHovered = (el === this.hoveredNodeEl);
            const isSelected = (el === this.selectedNodeEl);
            const isDimmed = !!highlightedIds && !highlightedIds.has(node.id);
            const isConnected = !!highlightedIds && highlightedIds.has(node.id) && !isSelected;

            const materialConfig = window.NewsGraph.getNodeMaterialConfig(
                node, this.tickerPriceMap, this.preIpoSymbols,
                isSelected, isHovered, true
            );
            el.setAttribute('material', materialConfig);

            const targetOpacity = isDimmed ? DIM_OPACITY : ((isSelected || isConnected) ? 1 : materialConfig.opacity);
            const meshObj = el.getObject3D('mesh');
            if (meshObj) {
                meshObj.renderOrder = 10;
                const mats = Array.isArray(meshObj.material) ? meshObj.material : [meshObj.material];
                mats.forEach(mat => {
                    if (mat) {
                        mat.opacity = targetOpacity;
                        mat.depthWrite = !isDimmed;
                        mat.depthTest = true;
                        mat.needsUpdate = true;
                    }
                });
            }

            el.object3D.visible = true;

            const isFresh = node.freshness && (node.freshness.status === 'inflection' || node.freshness.status === 'new');
            el.userData.isFresh = !!isFresh && !isDimmed;
            if (isFresh) {
                el.userData.emissiveMin = 0.05;
                el.userData.emissiveMax = 0.6;
            }

            window.NewsGraph.updateSelectionOutline(
                el,
                isSphere,
                el.userData.radius,
                isSelected || isConnected,
                { opacity: isSelected ? 0.85 : 0.58 }
            );
        });

        if (this.labelData) {
            this.labelData.forEach(({ textEl, nodeId }) => {
                const isDimmed = !!highlightedIds && !highlightedIds.has(nodeId);
                if (!textEl || !textEl.object3D) return;
                textEl.object3D.traverse(object => {
                    const materials = Array.isArray(object.material) ? object.material : [object.material];
                    materials.forEach(material => {
                        if (!material) return;
                        material.transparent = true;
                        material.opacity = isDimmed ? 0.08 : 1;
                        material.needsUpdate = true;
                    });
                });
            });
        }

        if (this.edgesGroup) {
            this.edgesGroup.children.forEach(mesh => {
                if (!mesh.material) return;
                mesh.renderOrder = 10;
                mesh.visible = true;
                if (!selectedNodeId) {
                    mesh.material.color.set(0x94a3b8);
                    mesh.material.opacity = mesh.userData.baseOpacity || 0.5;
                } else {
                    const isConnected =
                        mesh.userData.sourceId === selectedNodeId ||
                        mesh.userData.targetId === selectedNodeId;
                    if (isConnected) {
                        mesh.material.color.set(0x38bdf8);
                        mesh.material.opacity = Math.min(1.0, (mesh.userData.baseOpacity || 0.5) + 0.35);
                    } else {
                        mesh.material.color.set(0x94a3b8);
                        mesh.material.opacity = DIM_OPACITY;
                    }
                }
                mesh.material.depthTest = true;
                mesh.material.needsUpdate = true;
            });
        }

        if (this.orbitSphere && this.orbitSphere.children && this.orbitSphere.children.length > 0) {
            const mat = this.orbitSphere.children[0].material;
            const eqMat = this.orbitSphere.children[this.orbitSphere.children.length - 1].material;
            if (mat && eqMat) {
                if (selectedNodeId) {
                    mat.opacity = 0.1;
                    eqMat.opacity = 0.1;
                } else {
                    mat.opacity = 1.0;
                    eqMat.opacity = 1.0;
                }
                mat.needsUpdate = true;
                eqMat.needsUpdate = true;
            }
        }
    },

    setSelectedNodeEl: function (meshEl, node, triggerEvent = true) {
        const prevSelected = this.selectedNodeEl;

        if (meshEl === prevSelected) {
            if (meshEl) {
                this.selectedNodeEl = null;
            }
        } else {
            this.selectedNodeEl = meshEl;
        }

        if (window.VRPanelsSlidingManager) {
            window.VRPanelsSlidingManager.setSelectedEl(this.selectedNodeEl);
        }

        this.updateNodeVisuals();

        if (triggerEvent) {
            this.el.sceneEl.emit('news-graph-node-clicked', {
                node: this.selectedNodeEl ? node : null,
                data: this.graphData
            });
        }
    },

    orientCones: function () {
        if (!this.coneInfos || this.coneInfos.length === 0) return;
        const THREE = window.THREE || AFRAME.THREE;

        const parentWorldQuat = new THREE.Quaternion();
        const firstCone = this.coneInfos[0].el.object3D;
        if (firstCone && firstCone.parent) {
            firstCone.parent.getWorldQuaternion(parentWorldQuat);
        }
        const parentQuatInv = parentWorldQuat.clone().invert();

        const flipQuat = new THREE.Quaternion().setFromAxisAngle(
            new THREE.Vector3(1, 0, 0), Math.PI
        );

        this.coneInfos.forEach(info => {
            if (info.el && info.el.object3D) {
                const q = parentQuatInv.clone();
                if (info.flipped) q.multiply(flipQuat);
                info.el.object3D.quaternion.copy(q);
            }
        });
    },
    updateGlowPulse: function () {
        const time = this.el.sceneEl ? this.el.sceneEl.time : performance.now();
        if (this.meshMap) {
            window.NewsGraph.updateGlowPulse(Object.values(this.meshMap), time, 1.1, 1.6);
        }
    },
    applyRenderFixes: function() {
        if (this.labelData) {
            this.labelData.forEach(data => {
                const { textEl } = data;
                if (textEl && textEl.object3D) {
                    textEl.object3D.renderOrder = 9999;
                }
            });
        }
    },

    _rebuildEdgeGeometries: function () {
        if (!this.edgesGroup || !this.links || !this.meshMap) return;
        const THREE = window.THREE || AFRAME.THREE;

        this.edgesGroup.children.forEach(mesh => {
            const mA = this.meshMap[mesh.userData.sourceId];
            const mB = this.meshMap[mesh.userData.targetId];
            if (!mA || !mB) return;

            const p1 = mA.object3D.position.clone();
            const p2 = mB.object3D.position.clone();

            if (mesh.geometry) mesh.geometry.dispose();
            mesh.geometry = new THREE.TubeGeometry(
                new THREE.LineCurve3(p1, p2),
                1,
                mesh.userData.thickness || 0.04,
                6,
                false
            );
        });
    },

    _tickAnimations: function (timeDelta) {
        const ease = t => t * t * (3 - 2 * t);
        const ANIM_DURATION = 600;

        let needsEdgeRebuild = false;

        if (this._focusAnim && this._focusAnim.type === 'focus') {
            const anim = this._focusAnim;
            anim.t = Math.min(1, anim.t + timeDelta / ANIM_DURATION);
            const et = ease(anim.t);
            anim.entries.forEach(entry => {
                if (entry.nodeEl && entry.nodeEl.object3D) {
                    entry.nodeEl.object3D.position.lerpVectors(entry.fromPos, entry.toPos, et);
                }
            });
            needsEdgeRebuild = true;
            if (anim.t >= 1) {
                this._focusAnim = null;
            }
        }

        if (this._resetAnims && this._resetAnims.length > 0) {
            let allDone = true;
            this._resetAnims.forEach(anim => {
                if (anim.t < 1) {
                    anim.t = Math.min(1, anim.t + timeDelta / ANIM_DURATION);
                    const et = ease(anim.t);
                    if (anim.nodeEl && anim.nodeEl.object3D) {
                        anim.nodeEl.object3D.position.lerpVectors(anim.fromPos, anim.toPos, et);
                    }
                    if (anim.t < 1) allDone = false;
                }
            });
            needsEdgeRebuild = true;
            if (allDone) {
                this._resetAnims = null;
            }
        }

        if (needsEdgeRebuild) {
            this._rebuildEdgeGeometries();
        }
    },

    tick: function (time, timeDelta) {
        this._nodeClickedThisFrame = false;

        if (!this.lastRenderFixTime || time - this.lastRenderFixTime > 500) {
            this.applyRenderFixes();
            this.lastRenderFixTime = time;
        }

        this.orientCones();
        this.updateGlowPulse();
        this._tickAnimations(timeDelta);

        if (!this.lastStateCheckTime || time - this.lastStateCheckTime > 200) {
            this.lastStateCheckTime = time;

            const canSlideAndHover = window.VRPanelsSlidingManager ? window.VRPanelsSlidingManager._canApplySlideAndHover() : true;
            if (!canSlideAndHover) {
                const leftPanel = this.leftPanelEl = this.leftPanelEl || document.getElementById('left-panel-2');
                if (leftPanel) {
                    const bgDark = leftPanel.querySelector('.background-panel-dark');
                    const bgLight = leftPanel.querySelector('.background-panel-light');
                    if (bgDark && bgDark.hasAttribute('data-raycastable')) bgDark.removeAttribute('data-raycastable');
                    if (bgLight && bgLight.hasAttribute('data-raycastable')) bgLight.removeAttribute('data-raycastable');
                    const backing = leftPanel.querySelector('.ng-backing-panel');
                    if (backing && backing.getAttribute('visible') !== 'false') backing.setAttribute('visible', false);
                }
                const rightPanel = this.rightPanelEl = this.rightPanelEl || document.getElementById('right-container');
                if (rightPanel) {
                    const bgDark = rightPanel.querySelector('.background-panel-dark');
                    const bgLight = rightPanel.querySelector('.background-panel-light');
                    if (bgDark && bgDark.hasAttribute('data-raycastable')) bgDark.removeAttribute('data-raycastable');
                    if (bgLight && bgLight.hasAttribute('data-raycastable')) bgLight.removeAttribute('data-raycastable');
                    const backing = rightPanel.querySelector('.ng-backing-panel');
                    if (backing && backing.getAttribute('visible') !== 'false') backing.setAttribute('visible', false);
                }
            } else {
                if (this.selectedNodeEl) {
                    const leftPanel = this.leftPanelEl = this.leftPanelEl || document.getElementById('left-panel-2');
                    if (leftPanel) {
                        const bgDark = leftPanel.querySelector('.background-panel-dark');
                        const bgLight = leftPanel.querySelector('.background-panel-light');
                        if (bgDark && !bgDark.hasAttribute('data-raycastable')) bgDark.setAttribute('data-raycastable', '');
                        if (bgLight && !bgLight.hasAttribute('data-raycastable')) bgLight.setAttribute('data-raycastable', '');
                    }
                    const rightPanel = this.rightPanelEl = this.rightPanelEl || document.getElementById('right-container');
                    if (rightPanel) {
                        const bgDark = rightPanel.querySelector('.background-panel-dark');
                        const bgLight = rightPanel.querySelector('.background-panel-light');
                        if (bgDark && !bgDark.hasAttribute('data-raycastable')) bgDark.setAttribute('data-raycastable', '');
                        if (bgLight && !bgLight.hasAttribute('data-raycastable')) bgLight.setAttribute('data-raycastable', '');
                    }
                }
            }
        }

        if (!this.labelData || this.labelData.length === 0) return;
        const cameraEl = document.querySelector('[camera]');
        if (!cameraEl || !cameraEl.object3D) return;
        
        const THREE = window.THREE || AFRAME.THREE;
        const cameraPos = new THREE.Vector3();
        cameraEl.object3D.getWorldPosition(cameraPos);
        
        this.labelData.forEach(data => {
            const { meshEl, textEl, r } = data;
            if (meshEl && meshEl.object3D && textEl && textEl.object3D && textEl.object3D.parent) {
                const nodeWorldPos = new THREE.Vector3();
                meshEl.object3D.getWorldPosition(nodeWorldPos);

                const worldScaleVec = new THREE.Vector3();
                this.el.object3D.getWorldScale(worldScaleVec);
                const worldRadius = r * worldScaleVec.y;

                const GAP = Math.max(0.015, worldRadius * 0.20);

                const toCamera = new THREE.Vector3()
                    .subVectors(cameraPos, nodeWorldPos)
                    .normalize();

                const labelWorldPos = nodeWorldPos.clone()
                    .addScaledVector(toCamera, worldRadius + GAP);

                const localPos = textEl.object3D.parent.worldToLocal(labelWorldPos);
                textEl.object3D.position.copy(localPos);

                textEl.object3D.lookAt(cameraPos);
            }
        });
    },
    adjustScaleToFit: function (nodes, meshMap, vrDistanceScale = 1.0) {
        let maxDist = 0;
        nodes.forEach(node => {
            const el = meshMap[node.id];
            if (el) {
                const d = el.object3D.position.length();
                if (d > maxDist) maxDist = d;
            }
        });
        if (maxDist > 0) {
            const desiredRadius = 0.5 * vrDistanceScale;
            const scale = desiredRadius / maxDist;
            this.el.setAttribute('scale', `${scale} ${scale} ${scale}`);
            
            if (this.labelsContainer) {
                const invScale = 1 / scale;
                this.labelsContainer.setAttribute('scale', `${invScale} ${invScale} ${invScale}`);
            }
        }
    },
    selectNodeById: function(nodeId, triggerEvent = true) {
        if (!this.nodes || !this.meshMap) return;
        const normalizedId = String(nodeId).toUpperCase().trim();

        let foundNode = null;
        let foundMesh = null;

        for (const node of this.nodes) {
            const nodeIdUp = String(node.id || '').toUpperCase();
            const symUp    = String(node.symbol || '').toUpperCase();
            const grouped  = (node.grouped_tickers || []).map(s => String(s).toUpperCase());

            if (nodeIdUp === normalizedId || symUp === normalizedId || grouped.includes(normalizedId)) {
                foundNode = node;
                foundMesh = this.meshMap[node.id] || null;
                break;
            }
        }

        if (!foundNode && this.graphData) {
            const ticker = (this.graphData.tickers || []).find(t => {
                const symUp   = String(t.symbol || t.id || '').toUpperCase();
                const idUp    = String(t.id || '').toUpperCase();
                const grouped = (t.grouped_tickers || []).map(s => String(s).toUpperCase());
                return symUp === normalizedId || idUp === normalizedId || grouped.includes(normalizedId);
            });
            if (ticker) {
                foundNode = ticker;
                foundMesh = this.meshMap[ticker.id]
                    || this.meshMap[String(ticker.symbol || '').toUpperCase()]
                    || null;
            }
        }

        if (!foundNode) {
            console.warn('[news-graph-vr] selectNodeById: node not found for', normalizedId);
            return;
        }

        this.setSelectedNodeEl(foundMesh || null, foundNode, triggerEvent);
    }
});
